import { getPageUrl, getUserUrl } from '@domain/routes/urls';
import { Post } from '../types/Post';

export const getDisplayUserDetails = (
  displayEntity: Post['displayEntity'],
  userId: string,
  userNickname: string,
  userAvatarUrl: string,
): {
  displayUserId: string;
  displayUserNickname: string;
  displayUserAvatarUrl: string;
  displayUserUrl: string;
} => {
  if (
    displayEntity &&
    (displayEntity.__typename === 'Page' || displayEntity.__typename === 'User')
  ) {
    const displayUserId = displayEntity._id;
    const displayUserNickname = displayEntity.displayName;
    const displayUserAvatarUrl = displayEntity.displayIcon.url;
    const displayUserType = displayEntity.__typename;
    const displayUserUrl =
      displayUserType === 'Page'
        ? getPageUrl(displayUserId, displayUserNickname)
        : getUserUrl(displayUserNickname);
    return {
      displayUserId,
      displayUserNickname,
      displayUserAvatarUrl,
      displayUserUrl,
    };
  }
  return {
    displayUserId: userId,
    displayUserNickname: userNickname,
    displayUserAvatarUrl: userAvatarUrl,
    displayUserUrl: getUserUrl(userNickname),
  };
};
